import { format } from "date-fns";

import { LeadReplySentiment } from "@signalist/shared-types";

/** Render an ISO date as "14 Jan 2026"; empty string when missing/invalid. */
export function formatRelationshipDate(iso: string | null | undefined): string {
	if (!iso) {
		return "";
	}

	const date = new Date(iso);

	return Number.isNaN(date.getTime()) ? "" : format(date, "d MMM yyyy");
}

/** Reply-sentiment chip styling (semantic tokens) + the i18n key for its label. */
export const SENTIMENT_CHIP: Record<LeadReplySentiment, { classes: string; i18nKey: string }> = {
	INTERESTED: {
		classes: "bg-status-success-light text-status-success",
		i18nKey: "inbox.relationshipHover.sentiment.INTERESTED",
	},
	NOT_INTERESTED: {
		classes: "bg-status-error-light text-status-error",
		i18nKey: "inbox.relationshipHover.sentiment.NOT_INTERESTED",
	},
	BAD_TIMING: {
		classes: "bg-status-warning-light text-status-warning",
		i18nKey: "inbox.relationshipHover.sentiment.BAD_TIMING",
	},
	WRONG_PERSON: {
		classes: "bg-status-wrong-person-light text-status-wrong-person",
		i18nKey: "inbox.relationshipHover.sentiment.WRONG_PERSON",
	},
	NEUTRAL: {
		classes: "bg-status-info-light text-status-info",
		i18nKey: "inbox.relationshipHover.sentiment.NEUTRAL",
	},
};

/** Deterministic initials (max 2) for an avatar fallback. */
export function getInitials(name: string): string {
	return name
		.trim()
		.split(/\s+/)
		.slice(0, 2)
		.map((word) => word[0] ?? "")
		.join("")
		.toUpperCase();
}
